import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import styled from 'styled-components/macro';
import { WxButton, WxLabel, WxText } from '../components';
import { CartItemList } from '../components/pages/cart/CartItemList';
import { RedLink } from '../components/pages/order/OrderCard';
import { CartErrors } from '../components/ui/cartErrors/CartErrors';
import { CustomNav } from '../components/ui/customNav/CustomNav';
import { EmptyPlaceholder } from '../components/ui/notFound/EmptyPlaceholder';
import useBankroll from '../hooks/api/queries/useBankroll';
import { useCartContext } from '../hooks/context/useCartContext';
import useJwt from '../hooks/utils/useJwt';
import { __ } from '../i18n/l10n';
import { breakpoint } from '../styles/constants';
import { SLUG_DELIVERY } from '../styles/slugs';
import { appendCommitHash } from '../utils/appendHash';
import { splitNumber } from '../utils/splitNumber';
import { PageWrapper } from './Category';

export const Cart = () => {
  const { cart, emptyCart } = useCartContext();
  const jwt = useJwt();
  const navigate = useNavigate();
  const { data: bankroll } = useBankroll();

  useEffect(() => {
    const page = document.getElementById('page');
    if (page) page.style.transform = 'none';
  }, []);
  if (!jwt) navigate(appendCommitHash('/'));

  return (
    <PageWrapper>
      <CartErrors />
      <CustomNav
        label={`${__('Cart')} ${
          cart.totalArticles > 0 ? `(${cart.totalArticles})` : ''
        }`}
        navStyle="cross"
        forceDesktopLabelCenter
      />

      {cart.totalArticles > 0 ? (
        <>
          <CartItemList />
          <CartTopRow>
            <RedLinkContainer>
              <RedLink onClick={() => emptyCart()}>{__('Empty Cart')}</RedLink>
            </RedLinkContainer>
            <CartTotalDiv>
              <div>
                <WxLabel label="Total" />
                <WxLabel
                  label={`${splitNumber(cart.totalMilesAmount)} ${__('MILES')}`}
                />
              </div>
              <div>
                <WxText text={__('Delivery')} darkMode />
                <WxText text={__('Included')} darkMode />
              </div>
              <WxButton
                label={__('Place order')}
                onClick={() => {
                  navigate(appendCommitHash(`/${SLUG_DELIVERY}`));
                }}
                type={'validation'}
                disabled={cart.totalMilesAmount > (bankroll ?? 0)}
                expand
              />
              {cart.totalMilesAmount > (bankroll ?? 0) && (
                <WxText
                  type={'alert'}
                  align={'center'}
                  text={__('Not enough miles. Please remove some items.')}
                  darkMode
                />
              )}
            </CartTotalDiv>
          </CartTopRow>
        </>
      ) : (
        <EmptyPlaceholder type="cart" />
      )}
    </PageWrapper>
  );
};

const CartTotalDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  padding-top: 0.75rem;

  > div {
    display: flex;
    justify-content: space-between;
  }

  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  padding-bottom: 1.25rem;
  padding-inline: 1.25rem;
  background-color: black;

  @media (min-width: ${breakpoint}) {
    padding-inline: none;
    width: unset;
    position: static;
    padding-inline: unset;

    min-width: 264px;
    margin-left: auto;
    margin-bottom: 3.75rem;
  }
`;

const CartTopRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
const RedLinkContainer = styled.div`
  padding-top: 0.75rem;
`;
